import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { forwardRef, useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import { layout } from '../../styles/system';
import { jsx as _jsx } from "react/jsx-runtime";
const pulseAnimation = /*#__PURE__*/keyframes(["0%{transform:scale(0);opacity:1;}100%{transform:scale(1.0);opacity:0;}"]);
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "jp4dfu-0"
})(["display:flex;"]);

const getAnimationDelay = index => {
  switch (index) {
    case 0:
      return 0.2;

    case 2:
      return 0.4;

    default:
      return 0;
  }
};

const Dot = /*#__PURE__*/styled.div.withConfig({
  displayName: "Dot",
  componentId: "jp4dfu-1"
})(["", ";background-color:currentColor;border-radius:100%;transform-origin:center;opacity:0;animation:", " 0.8s linear ", "s infinite;"], layout.size, pulseAnimation, props => getAnimationDelay(props.index));
const Loader = /*#__PURE__*/forwardRef(function Loader(_ref, forwardedRef) {
  let {
    numDots = 3,
    size = 4.5
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["numDots", "size"]);

  const dots = useMemo(() => new Array(numDots).fill(null).map((_, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _jsx(Dot, {
    size: size,
    index: index
  }, index)), [numDots, size]);
  return /*#__PURE__*/_jsx(Container, Object.assign({
    ref: forwardedRef,
    role: "status",
    "aria-label": "loading"
  }, restProps, {
    children: dots
  }));
});
Loader.propTypes = {
  numDots: T.number,
  size: T.number
};
export { Loader };